import { ThemeProvider } from "@mui/material";
import { Auth } from "components/Parts/Organisms/Auth";
import { DetailPage } from "components/Parts/Organisms/DetailPage";
import { DetailProps } from "components/Parts/Organisms/DetailPage/interfaces";
import { pubPdfTheme } from "components/Parts/Organisms/DetailPage/theme";
import React from "react";

export const Detail = React.memo((props: DetailProps) => (
  <Auth>
    {props.forAnonymous ? (
      <ThemeProvider theme={pubPdfTheme}>
        <DetailPage {...props} />
      </ThemeProvider>
    ) : (
      <DetailPage {...props} />
    )}
  </Auth>
));
